import {Map} from 'immutable';
import {DefaultRootState} from 'react-redux';
import {createSelector} from 'reselect';

import {UserSerializedType} from 'sweet-types';

export const getTeammatesSelector = createSelector<
  DefaultRootState,
  Array<UserSerializedType>,
  Array<any>
>(
  (state) => state.userArea.get('usersv2').toJS().byId as any,
  (users) => Object.values(users)
);
export const userSelector = createSelector<
  DefaultRootState,
  UserSerializedType | null,
  Map<unknown, unknown> | undefined
>(
  (state, userId) => state.userArea.getIn(['usersv2', 'byId', userId]),
  (user) => (user ? (user.toJS() as any) : null)
);
